import React from "react";
import "../Styles/WWAAbout.css";

const WWAAbout = () => {
  return (
    <>
      <section className="sectionWWAAbout">
        <p className="WWAAboutText">
          Welcome to Tabernacle of Meeting, a vibrant parish of the Redeemed
          Christian Church of God (RCCG). Under the anointed leadership of our
          General Overseer, Pastor E.A. Adeboye, we are a family of believers
          committed to holiness, worship, and spreading the Gospel. We are a
          place where faith is nurtured, hope is restored, and love is lived
          out. Through inspiring worship services, life-changing Bible studies,
          and prayer gatherings, we equip every generation to grow in Christ.
          <br /> <br />
          Our outreach ministries reflect Christ's heart—empowering the
          vulnerable, mentoring, and spreading the Gospel through acts of
          kindness and service. Rooted in scripture, led by the Holy Spirit, and
          united in purpose, we exist to know Christ and make Him known. Whether
          you're new to faith or seeking a spiritual home, you belong here. Join
          us as we walk in power, unity, and grace—one church, one mission, one
          Lord.
        </p>
      </section>
    </>
  );
};

export default WWAAbout;
